module.exports = __webpack_public_path__ + "static/fonts/Quicksand-Medium.019d7aa.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Quicksand-Medium.eot
// module id = Z4wl
// module chunks = 1